var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8525 6.99996C2.8525 4.42263 5.18894 2.33329 8.07109 2.33329C10.9532 2.33329 13.2897 4.42263 13.2897 6.99996V7.58329H11.985C10.9042 7.58329 10.0281 8.36679 10.0281 9.33329V11.0833C10.0281 12.0498 10.9042 12.8333 11.985 12.8333H12.6374C13.7182 12.8333 14.5943 12.0498 14.5943 11.0833V6.99996C14.5943 3.7783 11.6738 1.16663 8.07109 1.16663C4.4684 1.16663 1.54785 3.7783 1.54785 6.99996V11.0833C1.54785 12.0498 2.42402 12.8333 3.50482 12.8333H4.15715C5.23795 12.8333 6.11412 12.0498 6.11412 11.0833V9.33329C6.11412 8.36679 5.23795 7.58329 4.15715 7.58329H2.8525V6.99996ZM2.8525 8.74996V11.0833C2.8525 11.4055 3.14455 11.6666 3.50482 11.6666H4.15715C4.51741 11.6666 4.80947 11.4055 4.80947 11.0833V9.33329C4.80947 9.01113 4.51741 8.74996 4.15715 8.74996H2.8525ZM13.2897 8.74996H11.985C11.6248 8.74996 11.3327 9.01113 11.3327 9.33329V11.0833C11.3327 11.4055 11.6248 11.6666 11.985 11.6666H12.6374C12.9976 11.6666 13.2897 11.4055 13.2897 11.0833V8.74996Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.6545f4237d7b3daed84da7a7b1100764.svg";
export { ForwardRef as ReactComponent };